/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { ListItem, ListItemText, Collapse } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

import ScreenItem from './ScreenItem'

const styles = theme => ({

})

class SectionItem extends Component {
    state = {
        open : false
    }

    componentDidMount () {
        //console.log("Child Routes : ", this.getChildRoutes(this.props.config))
        if (this.getChildRoutes(this.props.config).includes(this.props.cur_route)) {
            this.setState({...this.state, open : true})
        }
    }

    getChildRoutes = (config) => {
        let child_routes = config.screens.map(item => {
            if (item.type === 'section') {
                return this.getChildRoutes(item)
            } else {
                return item.route
            }
        })

        child_routes = child_routes.flat()
        return child_routes
    }

    renderChildren = () => {
        let items = this.props.config.screens.map(item => {
            if (item.type === 'section') {
                return (
                    <SectionItem
                        id = {"sidebar-section-" + item.name.replace(/\s/g, "")}
                        key = {item.id} 
                        config = {item} 
                        level = {this.props.level + 1} 
                        goToPage = {(path) => this.props.goToPage(path)}
                        cur_route = {this.props.cur_route}
                    />
                )
            } else {
                return (
                    <ScreenItem 
                        id = {"sidebar-screen-" + item.name.replace(/\s/g, "")}
                        key = {item.route} 
                        config = {item} 
                        goToPage = {(path) => this.props.goToPage(path)} 
                        level = {this.props.level + 1}
                        cur_route = {this.props.cur_route}
                    />
                )
            }
        })

        return items
    }

    render() { 
        return (
            <Fragment>
                <ListItem
                    id = {this.props.id}
                    style = {{paddingLeft : (this.props.level * 20) + "px"}}
                    key = {this.props.config.id}
                    button
                    onClick = {() => this.setState({...this.state, open : !this.state.open})}
                >
                    <ListItemText
                        primary={this.props.config.name}
                        primaryTypographyProps={{ variant:  "subtitle2"}}
                    />
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in = {this.state.open}>
                    {this.renderChildren()}
                </Collapse>
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(SectionItem);